module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-13-4a7f3ddaf07b2902e638737180367781.png";